/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { L as ListHeader, d as defineCustomElement$1 } from './list-header.js';

const IonListHeader = ListHeader;
const defineCustomElement = defineCustomElement$1;

export { IonListHeader, defineCustomElement };
